import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Navbar from './component/Navbar';
import Universities from './universities';
import HeroSection from './component/HeroSection';
import Features from './component/Features';
import About from './component/About';
import Testimonials from './component/Testimonials';
import Contact from './component/Contact';

const HelloWorld = () => {
    const url = window.location.origin;  
    const parsedUrl = new URL(url);
    const domain = parsedUrl.hostname;

    const [loading, setLoading] = useState(true);
    const [appLogo, setAppLogo] = useState(`/assets/icon_network.png`);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    
    const URL_GET_PROJECT = `${process.env.REACT_APP_API_BASE_URL}api/system/home?domain=${domain}`;
    
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;            
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(URL_GET_PROJECT).then((value) => {
            setAppLogo(`${process.env.REACT_APP_API_URL}upload/logo/${value.data.logo}`)
        });

    }, [domain]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <div >
            <Navbar appLogo={appLogo} toggleMenu={toggleMenu} isMenuOpen={isMenuOpen}/>

            <HeroSection />
            <Features />
            <Universities/>
            <About />
            <Testimonials />
            <Contact />
        </div>
    )
}

export default HelloWorld;